function showCheckoutLoadingImg(){
document.getElementById('loading_img').style.display = 'inline';
document.getElementById('loading_message').innerHTML = '<blink>Loading secure checkout...</blink>'
}
function setSelectedMenuTab(name){
  //resetTabs();
  tab = document.getElementById(name + '-tab');
  tab.style.backgroundImage = "url('top-menu-tab-" + name + "-selected.jpg')";
}
function resetTabs(){
  document.getElementById('home-tab').style.backgroundImage = "url('/images/top-menu-tabs/top-menu-tab-home.jpg')";
  document.getElementById('products-tab').style.backgroundImage = "url('/images/top-menu-tabs/top-menu-tab-products.jpg')";
  document.getElementById('learning-tab').style.backgroundImage = "url('/images/top-menu-tabs/top-menu-tab-learning.jpg')";
  document.getElementById('stories-tab').style.backgroundImage = "url('/images/top-menu-tabs/top-menu-tab-stories.jpg')";
  document.getElementById('store-tab').style.backgroundImage = "url('/images/top-menu-tabs/top-menu-tab-store.jpg')";
}
function setMenuTab(menu_name, tab_name){
  if (menu_name == 'product'){
    a = ['overview','details','usage','faq'];
    resetSubTabs(menu_name, a);
  }
  else if (menu_name == 'about'){
    a = ['mission','secure','quality'];
    resetSubTabs(menu_name, a);
  }
  tabDiv = document.getElementById(menu_name + '-tab-' + tab_name);
  tabLinkDiv = document.getElementById(menu_name + '-tab-link-' + tab_name);

  tabDiv.style.display = 'block';
  tabLinkDiv.className = 'menu-tab-selected';
}

function resetSubTabs(menu_name, a){
  for (x=0; x < a.length; x++){
    tabDiv = document.getElementById(menu_name + '-tab-' + a[x]);
    tabLinkDiv = document.getElementById(menu_name + '-tab-link-' + a[x]);

    tabDiv.style.display = 'none';
    tabLinkDiv.className = 'menu-tab-not-selected';
  }
}
function resetAboutTabs(){
  document.getElementById('about-tab-mission').style.display = 'none';
  document.getElementById('about-tab-secure').style.display = 'none';
  document.getElementById('about-tab-quality').style.display = 'none';
}
